import React from "react";

const stageColors = ["#2563eb", "#7c3aed", "#eab308"]; // Blue, Purple, Gold (yellow-500)

type StageCircleProps = {
  current: number; // 1-based
  total: number;
  isGold?: boolean; // for gold after reward
  size?: number;
  fontSize?: number;
  style?: React.CSSProperties;
  className?: string;
  darkMode?: boolean;
};

const StageCircle: React.FC<StageCircleProps> = ({
  current,
  total,
  isGold = false,
  size = 44,
  fontSize = 18,
  style,
  className = "",
  darkMode = false,
}) => {
  // Gold if rewarded, else use color by stage
  const color = isGold ? "#eab308" : stageColors[(current - 1) % stageColors.length];
  const borderColor = darkMode ? "#374151" : "#e5e7eb"; // gray-700 or gray-200
  const textColor = "#fff";

  return (
    <div
      className={`flex items-center justify-center font-bold ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: color,
        color: textColor,
        fontSize,
        border: `3px solid ${borderColor}`,
        fontFamily: "Feather Bold",
        flexShrink: 0,
        ...style,
      }}
    >
      {`${current}/${total}`}
    </div>
  );
};

export default StageCircle;
